import { useCallback, useState } from 'react';

// Why the comma after the generic type declaration?
// Answer: https://www.ashbyhq.com/blog/engineering/generic-arrow-function-in-tsx
export const useTimeoutState = <T,>(
	defaultState: T,
): [T, (newState: T, opts?: { timeout: number }) => void] => {
	const [state, _setState] = useState<T>(defaultState);
	const [currentTimeoutId, setCurrentTimeoutId] = useState<
		NodeJS.Timeout | undefined
	>();

	const setState = useCallback(
		(newState: T, opts?: { timeout: number }) => {
			if (currentTimeoutId != null) {
				clearTimeout(currentTimeoutId);
			}

			_setState(newState);

			const id = setTimeout(
				() => _setState(defaultState),
				opts?.timeout || 1000,
			);
			setCurrentTimeoutId(id);
		},
		[currentTimeoutId, defaultState],
	);
	return [state, setState];
};
